/** Apex domain used for `{subdomain}.domain` tenant hosts. */
export function getAppDomain(): string {
  const fromEnv = (import.meta.env.VITE_APP_DOMAIN as string | undefined)?.trim();
  return (fromEnv || 'birdmansuite.com').replace(/^\.+/, '');
}

const CONTROL_PLANE_SUBDOMAINS = new Set([
  'www',
  'api',
  'app',
  'mail',
  'birdman-demo',
  'demo',
]);

/** Tenant slug from `avitest.birdmansuite.com` (not the control-plane demo host).
 * Keep CONTROL_PLANE_SUBDOMAINS in sync with packages/api/src/modules/fleet/tenant-hostname.ts (T4).
 */
export function getTenantSubdomain(hostname?: string): string | null {
  if (typeof window === 'undefined' && !hostname) return null;
  const host = (hostname || window.location.hostname).toLowerCase();
  const domain = getAppDomain();
  const suffix = `.${domain}`;
  if (!host.endsWith(suffix)) return null;
  const sub = host.slice(0, -suffix.length);
  if (!sub || sub.includes('.')) return null;
  if (CONTROL_PLANE_SUBDOMAINS.has(sub) || sub.endsWith('-api')) return null;
  return sub;
}

function defaultApiUrl(): string {
  return (import.meta.env.VITE_API_URL as string | undefined) || '/api';
}

/** API base for fetch client (includes /api path). */
export function getApiBaseUrl(): string {
  const tenant = getTenantSubdomain();
  if (tenant) {
    return `https://${tenant}-api.${getAppDomain()}/api`;
  }
  return defaultApiUrl();
}

/** Host origin for static assets, photos, and WebSocket (no /api suffix). */
export function getApiHostUrl(): string {
  const apiUrl = getApiBaseUrl();
  if (apiUrl.startsWith('http')) {
    return apiUrl.replace(/\/api\/?$/, '') || apiUrl;
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:3001';
}
